export default "__VITE_ASSET__CFynMCtB__"